import Vue from 'vue'
import axios from 'axios'

if (document.getElementById('vue-participants')) {
  new Vue({
    el: '#vue-participants',
    data() {
      return {
        apiUrl: `${location.origin}/wp-json/orange-campus/v1/participants`,
        apiCategoriesUrl: `${location.origin}/wp-json/wp/v2/participant_categories`,
        loading: true,
        participants: [],
        categories_participants: [],
        categories_slug: [],
        filters: {},
        selectedCategory: {},
        contact_url: null
      }
    },
    mounted() {
      this.getCategoriesParticipants()
    },
    computed: {
    },
    methods: {
      getCategoriesParticipants() {
        axios
          .get(this.apiCategoriesUrl, {
            params: {
              lang: document.getElementById('vue-participants').dataset.lang
            }
          })
          .then(response => {
            this.categories_participants = response.data;
            this.categories_slug = this.categories_participants.map((category) => {
              return category.slug
            })
            if(window.location.hash) {
              const hash = window.location.hash.substring(1, window.location.hash.length);
              if(this.categories_slug.includes(hash)) {
                const category = this.categories_participants.find(element => element.slug === hash);
                this.selectedCategory = category
                this.updateCategory(category)
              }
            } else {
              const category = this.categories_participants[1]
              this.updateCategory(category)
              this.getParticipants()
            }
          });
      },
      getParticipants() {
        this.loading = true
        let paramsParticipants = {
          lang: document.getElementById('vue-participants').dataset.lang
        }

        if (this.filters.category) {
          paramsParticipants = {
            category: this.filters.category,
            lang: document.getElementById('vue-participants').dataset.lang
          }
        }

        axios
          .get(this.apiUrl, {
            params: paramsParticipants
          })
          .then(response => {
            this.participants = response.data.posts;
            this.contact_url = response.data.contact_url;
            this.contact_label = response.data.contact_label;
            this.loading = false;
          });
      },
      getParticipantThumbnail(participant, size) {
        if(participant.photo) {
          return participant.photo?.sizes[size]          
        }
        return true
      },
      updateCategory(category) {
        this.selectedCategory = category
        this.participants = []
        this.filters.category = category.id
        this.getParticipants()
      },
      getMore() {
				this.page++;
				this.getParticipants()
			}
    }
  })

}
